import type { App } from '../../types/app.types';

// Sample app registry - in a real app, this would come from an API
export const appRegistry: App[] = [
  {
    id: 'moving-motivators',
    name: 'Moving Motivators',
    description: 'Discover what truly motivates you and your team',
    icon: '🎮',
    category: 'game',
    order: 1,
    url: '/apps/moving-motivators',
  },
  {
    id: 'delegation-poker',
    name: 'Delegation Poker',
    description: 'Discover the right level of delegation for your team decisions',
    icon: '🃏',
    category: 'game',
    order: 2,
    url: '/apps/delegation-poker',
  },
  {
    id: 'planning-poker',
    name: 'Planning Poker',
    description: 'Estimate user story effort collaboratively with your team using story points',
    icon: '🂡',
    category: 'tool',
    order: 3,
    url: '/apps/planning-poker',
  },
  {
    id: 'kanban-board',
    name: 'Kanban Board',
    description: 'Visualize and manage your team workflow with collaborative kanban boards',
    icon: '📋',
    category: 'tool',
    order: 4,
    url: '/apps/kanban-board',
  },
];

export const getAppById = (id: string): App | undefined => {
  return appRegistry.find((app) => app.id === id);
};

export const getAppsByCategory = (category: string): App[] => {
  return appRegistry.filter((app) => app.category === category);
};
